export const FLAG_MARKER_ATTRIBUTE = 'data-confidence-flag';

export const FLAG_MARKER_ENABLED_ATTRIBUTE = `${FLAG_MARKER_ATTRIBUTE}-enabled`;
